"use strict";
var AnimationStyles = (function () {
    function AnimationStyles(styles) {
        this.styles = styles;
    }
    return AnimationStyles;
}());
exports.AnimationStyles = AnimationStyles;
//# sourceMappingURL=animation_styles.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/animation/animation_styles.js
 ** module id = 287
 ** module chunks = 0
 **/